import { get, post, put } from "./api_helper"

export const getFabricResourceAPI = params =>
  get("admin/master/fabric/page", params)

export const getFabricByIdAPI = id => get(`admin/master/fabric/${id}`)
export const getFabricListAPI = params =>
  get(`admin/master/fabric/list`, params)

// export const getFabricYearListAPI = id =>
//   get(`admin/master/fabric/${id}/year/list`)
export const getFabricYearListAPI = id =>
  get(`admin/master/fabric-trading-company/${id}/year/list`)

export const getFabricRankAPI = (id, year, seasonId) =>
  get(`admin/master/fabric/${id}/latest-rank/year/${year}/season/${seasonId}`)

export const getFabricSeasonListAPI = (id, year) =>
  get(`admin/master/fabric/${id}/year/${year}/season/list`)
// export const getFabricSeasonListAPI = (id, year) =>
  // get(`admin/master/fabric-trading-company/${id}/year/${year}/season/list`)

export const postFabricAPI = data => post("admin/master/fabric", data)

export const putFabricAPI = (data, id) => put(`admin/master/fabric/${id}`, data)

export const downloadFabricAPI = () =>
  get(`admin/master/fabric/download`, {}, { responseType: "blob" })

export const uploadFabricAPI = data => post(`admin/master/fabric/upload`, data)
